import 'react-hot-loader/patch'
import { AppContainer } from 'react-hot-loader'

import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'
import ReactGA from 'react-ga'
import GTMBuildParts from 'react-google-tag-manager/lib/build_parts'
import _ from 'lodash'

import store, { history } from './store'
import App from './containers/app'

const target = document.querySelector('#root')

const renderApp = () => {
  render(
    <AppContainer>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <App />
        </ConnectedRouter>
      </Provider>
    </AppContainer>,
    target
  )
}

const initGoogleTagManager = () => {
  if (!process.env.REACT_APP_GOOGLE_TAG_MANAGER) return

  const script = document.createElement('script')
  const noscript = document.createElement('noscript')
  document.head.appendChild(script)
  document.body.insertBefore(noscript, document.body.firstChild)

  const gtmParts = GTMBuildParts({ id: process.env.REACT_APP_GOOGLE_TAG_MANAGER })
  render(gtmParts.script, script)
  render(gtmParts.iframe, noscript)
}

const initGoogleAnalytics = () => {
  if (!process.env.REACT_APP_GOOGLE_ANALYTICS) return

  ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS)

  history.listen((location, action) => {
    ReactGA.set({ page: location.pathname + location.search })
    ReactGA.pageview(location.pathname + location.search)
  })
}

const initGoogleGTag = () => {
  if (!process.env.REACT_APP_GOOGLE_GTAG) return

  const ids = process.env.REACT_APP_GOOGLE_GTAG.split(',')
  const gtag_id = _.head(ids)
  const tail_ids = _.tail(ids)

  const script1 = document.createElement('script')
  const script2 = document.createElement('script')

  script1.src = `https://www.googletagmanager.com/gtag/js?id=${gtag_id}`
  script1.async = true

  document.head.appendChild(script1)
  document.head.appendChild(script2)

  const script_content = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());

    gtag('config', '${gtag_id}');
    ${_.map(tail_ids, id => `gtag('config', '${id}');`)}`

  render(script_content, script2)
}

const initStripe = () => {
  const script = document.createElement('script')
  document.head.appendChild(script)
  script.src = 'https://js.stripe.com/v3/'
}

initGoogleTagManager()
initGoogleAnalytics()
initGoogleGTag()
initStripe()
renderApp()

if (module.hot) {
  module.hot.accept('./containers/app', renderApp)
}



// WEBPACK FOOTER //
// ./src/index.js